export default "__VITE_ASSET__DJrguUY8__"